
import { Box } from '@mui/material';


const Auditrails = () => {
    return (
        <Box sx={{ alignItems: 'center' }}>
        </Box>
    );
}

export default Auditrails;
